import { Consultation } from 'types'

const PRE_VIDEO_STATES = new Set(['confirm', 'confirmed', 'paid', 'waiting'])

/**
 * ActionCable can deliver started+visio before an older in-flight GET returns.
 * The backend lifecycle cannot move started back to a queue state, so retain the
 * proven live session instead of tearing down the patient's call.
 */
export const mergeConsultationWithoutLiveRegression = (
  current: Consultation | undefined,
  incoming: Consultation
): Consultation => {
  if (!current || current.id !== incoming.id) return incoming
  if (current.state !== 'started' || !current.visioSession) return incoming

  const incomingLacksActiveSession =
    (incoming.state === 'started' && !incoming.visioSession) ||
    (!!incoming.state && PRE_VIDEO_STATES.has(incoming.state))

  return incomingLacksActiveSession ? current : incoming
}

export const mergeConsultationSnapshot = (
  current: readonly Consultation[],
  incoming: readonly Consultation[]
): Consultation[] => {
  const currentById = new Map(current.map((consultation) => [consultation.id, consultation]))
  const merged = incoming.map((consultation) =>
    mergeConsultationWithoutLiveRegression(currentById.get(consultation.id), consultation)
  )
  const incomingIds = new Set(incoming.map((consultation) => consultation.id))
  const activeMissingFromSnapshot = current.filter(
    (consultation) =>
      consultation.state === 'started' && !!consultation.visioSession && !incomingIds.has(consultation.id)
  )
  return [...merged, ...activeMissingFromSnapshot]
}
